<div class="mt-3 ms-2">
    <p *ngIf="labelTranslated" class="mb-3 fs-12 opacity-75">{{labelTranslated | translate}}</p>
    <p *ngIf="labelTranslated && valueTranslated" class="mb-3">{{valueTranslated | translate}}</p>
    <p *ngIf="(labelTranslated && !valueTranslated) || (!labelTranslated && !valueTranslated)" class="mb-3 opacity-75 fst-italic">{{labelTranslated | translate}}</p>
</div>